"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TranslationKey = void 0;
/* istanbul ignore file */
/**
 * DO NOT EDIT!
 * This file was autogenerated by npm script `localizations-codegen`.
 * Changes may cause incorrect behavior and will be lost when the file is regenerated.
 *
 * Run `npx localizations-codegen` to regenerate.
 */
let TranslationKey = exports.TranslationKey = /*#__PURE__*/function (TranslationKey) {
  TranslationKey["actionOutput"] = "actionOutput";
  TranslationKey["actionUsedQualifications"] = "actionUsedQualifications";
  TranslationKey["cancel"] = "cancel";
  TranslationKey["close"] = "close";
  TranslationKey["closeGodModeQuestion"] = "closeGodModeQuestion";
  TranslationKey["closeGodModeWindow"] = "closeGodModeWindow";
  TranslationKey["columnMenuFilter"] = "columnMenuFilter";
  TranslationKey["columnMenuHideColumn"] = "columnMenuHideColumn";
  TranslationKey["columnMenuLabel"] = "columnMenuLabel";
  TranslationKey["columnMenuManageColumns"] = "columnMenuManageColumns";
  TranslationKey["columnMenuShowColumns"] = "columnMenuShowColumns";
  TranslationKey["columnMenuSortAsc"] = "columnMenuSortAsc";
  TranslationKey["columnMenuSortDesc"] = "columnMenuSortDesc";
  TranslationKey["columnMenuUnsort"] = "columnMenuUnsort";
  TranslationKey["columnsPanelDragIconLabel"] = "columnsPanelDragIconLabel";
  TranslationKey["columnsPanelHideAllButton"] = "columnsPanelHideAllButton";
  TranslationKey["columnsPanelShowAllButton"] = "columnsPanelShowAllButton";
  TranslationKey["columnsPanelTextFieldLabel"] = "columnsPanelTextFieldLabel";
  TranslationKey["columnsPanelTextFieldPlaceholder"] = "columnsPanelTextFieldPlaceholder";
  TranslationKey["conditionActionExecutionTime"] = "conditionActionExecutionTime";
  TranslationKey["conditionOutput"] = "conditionOutput";
  TranslationKey["conditionQualifications"] = "conditionQualifications";
  TranslationKey["consultantNr"] = "consultantNr";
  TranslationKey["filterAllXValue"] = "filterAllXValue";
  TranslationKey["filterErrorsXValue"] = "filterErrorsXValue";
  TranslationKey["filterOperatorAfter"] = "filterOperatorAfter";
  TranslationKey["filterOperatorBefore"] = "filterOperatorBefore";
  TranslationKey["filterOperatorContains"] = "filterOperatorContains";
  TranslationKey["filterOperatorEndsWith"] = "filterOperatorEndsWith";
  TranslationKey["filterOperatorEquals"] = "filterOperatorEquals";
  TranslationKey["filterOperatorIs"] = "filterOperatorIs";
  TranslationKey["filterOperatorIsAnyOf"] = "filterOperatorIsAnyOf";
  TranslationKey["filterOperatorIsEmpty"] = "filterOperatorIsEmpty";
  TranslationKey["filterOperatorIsNotEmpty"] = "filterOperatorIsNotEmpty";
  TranslationKey["filterOperatorNot"] = "filterOperatorNot";
  TranslationKey["filterOperatorOnOrAfter"] = "filterOperatorOnOrAfter";
  TranslationKey["filterOperatorOnOrBefore"] = "filterOperatorOnOrBefore";
  TranslationKey["filterOperatorStartsWith"] = "filterOperatorStartsWith";
  TranslationKey["filterOptions"] = "filterOptions";
  TranslationKey["filterPanelAddFilter"] = "filterPanelAddFilter";
  TranslationKey["filterPanelColumns"] = "filterPanelColumns";
  TranslationKey["filterPanelDeleteIconLabel"] = "filterPanelDeleteIconLabel";
  TranslationKey["filterPanelInputLabel"] = "filterPanelInputLabel";
  TranslationKey["filterPanelInputPlaceholder"] = "filterPanelInputPlaceholder";
  TranslationKey["filterPanelLogicOperator"] = "filterPanelLogicOperator";
  TranslationKey["filterPanelOperator"] = "filterPanelOperator";
  TranslationKey["filterPanelOperatorAnd"] = "filterPanelOperatorAnd";
  TranslationKey["filterPanelOperatorOr"] = "filterPanelOperatorOr";
  TranslationKey["filterPanelRemoveAll"] = "filterPanelRemoveAll";
  TranslationKey["filterQualifiedXValue"] = "filterQualifiedXValue";
  TranslationKey["filterUsedXValue"] = "filterUsedXValue";
  TranslationKey["godModeBarTitle"] = "godModeBarTitle";
  TranslationKey["moment"] = "moment";
  TranslationKey["noData"] = "noData";
  TranslationKey["noRulesAvailable"] = "noRulesAvailable";
  TranslationKey["period"] = "period";
  TranslationKey["ruleDescription"] = "ruleDescription";
  TranslationKey["ruleId"] = "ruleId";
  TranslationKey["ruleSet"] = "ruleSet";
  TranslationKey["ruleType"] = "ruleType";
  TranslationKey["toolbarColumns"] = "toolbarColumns";
  TranslationKey["toolbarDensity"] = "toolbarDensity";
  TranslationKey["toolbarDensityComfortable"] = "toolbarDensityComfortable";
  TranslationKey["toolbarDensityCompact"] = "toolbarDensityCompact";
  TranslationKey["toolbarDensityStandard"] = "toolbarDensityStandard";
  TranslationKey["toolbarExport"] = "toolbarExport";
  TranslationKey["toolbarExportCSV"] = "toolbarExportCSV";
  TranslationKey["toolbarExportExcel"] = "toolbarExportExcel";
  TranslationKey["toolbarExportPrint"] = "toolbarExportPrint";
  TranslationKey["toolbarFilters"] = "toolbarFilters";
  TranslationKey["toolbarFiltersTooltipActiveOne"] = "toolbarFiltersTooltipActiveOne";
  TranslationKey["toolbarFiltersTooltipActiveXValue"] = "toolbarFiltersTooltipActiveXValue";
  TranslationKey["toolbarFiltersTooltipHide"] = "toolbarFiltersTooltipHide";
  TranslationKey["toolbarFiltersTooltipShow"] = "toolbarFiltersTooltipShow";
  TranslationKey["toolbarSelectColumns"] = "toolbarSelectColumns";
  TranslationKey["toolbarShowFilters"] = "toolbarShowFilters";
  return TranslationKey;
}({});